// extracted by mini-css-extract-plugin
export var aircallIframe = "_ko-3";
export var fabContainer = "_ko-5";
export var fabRinging = "_ko-6";
export var loadingOverlay = "_ko-4";
export var pulse = "_ko-7";
export var widgetContent = "_ko-2";
export var widgetPanel = "_ko-0";
export var widgetPanelExpanded = "_ko-1";